import Vue from 'vue';
export const state = Vue.observable({
  taxFlag: '',
  putaway: 0,
  ratePaymentType: 1,
  skuList: [], // 保存数据
  goodsSpecsAttrKeyList: [], // 保存数据
  remove_all: 0, // 删除全部 0  1为删除全部
  remove_skuList: [], // 删除sku
  remove_keyList: [], // 删除规格key
  edit_skuList: [], // 编辑sku
  edit_keyList: [], // 编辑规格key
  one_skuList: {}, // 单挑sku保存
  One_goodsSpecsAttrKeyList: [],
});

export const setRemoveAllDAta = () => {
  state.taxFlag = '';
  state.putaway = 0;
  state.ratePaymentType = 1;
  state.skuList = [];
  state.goodsSpecsAttrKeyList = [];
  state.remove_all = 0;
  state.remove_skuList = [];
  state.remove_keyList = [];
  state.edit_skuList = [];
  state.edit_keyList = [];
  state.one_skuList = {};
  state.One_goodsSpecsAttrKeyList = [];
};
// 是否上架状态 1为上架状态
export const setPutaway = e => {
  state.putaway = e;
};
// 单一
export const setOne_skuList = e => {
  console.log(JSON.stringify(e));
  state.one_skuList = e;
};
// 单一
export const setOne_goodsSpecsAttrKeyList = e => {
  console.log(JSON.stringify(e));
  state.One_goodsSpecsAttrKeyList = e;
};
// 删除全部
export const setRemove_all = e => {
  state.remove_all = e;
};
// 设置类型
export const setRatePaymentType = e => {
  state.ratePaymentType = e;
};
// 存编辑的值
export const setSkuListGoodsSpecsAttrKeyList = e => {
  state.goodsSpecsAttrKeyList = e.goodsSpecsAttrKeyList;
  state.skuList = e.skuList;
};
//  operationType 操作标识 1:保存 2:更新 3:删除
// 删除规格SKU
export const setRemove_skuList = e => {
  e.operationType = 3;
  state.remove_skuList.push(e);
  console.log(JSON.stringify(state.remove_skuList));
};

// 删除规格值
export const setRemove_keyList = e => {
  e.operationType = 3;
  state.remove_keyList.push(e);
  console.log(JSON.stringify(state.remove_keyList));
};
// 编辑规格SKU
export const setEdit_skuList = e => {
  e.operationType = 2;
  state.edit_skuList.push(e);
};

// 编辑规格值
export const setEdit_keyList = e => {
  e.operationType = 2;
  state.edit_keyList.push(e);
};
